import React, { useEffect, useState, useRef } from "react";

const CustomCursor = () => {
  const [hovered, setHovered] = useState(false);
  const [hidden, setHidden] = useState(true);
  const dotRef = useRef(null);
  const ringRef = useRef(null);

  const mouseCoords = useRef({ x: 0, y: 0 });
  const ringCoords = useRef({ x: 0, y: 0 });

  useEffect(() => {
    const onMouseMove = (e) => {
      mouseCoords.current.x = e.clientX;
      mouseCoords.current.y = e.clientY;
      setHidden(false);
    };

    const onMouseLeave = () => {
      setHidden(true);
    };

    const onMouseEnter = () => {
      setHidden(false);
    };

    // Global listener to check if hovering interactive elements
    const onMouseOver = (e) => {
      const target = e.target;
      if (!target) return;

      const isInteractive = target.closest(
        'a, button, [role="button"], input, textarea, select, .project-3d-card, .bento-card, .social-card, .slider-dot, .lang-btn'
      );
      if (isInteractive) {
        setHovered(true);
      } else {
        setHovered(false);
      }
    };

    window.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseleave", onMouseLeave);
    document.addEventListener("mouseenter", onMouseEnter);
    window.addEventListener("mouseover", onMouseOver);

    // Smooth Lerp animation loop for the outer ring
    let animationFrameId;
    const animateRing = () => {
      const ringSpeed = 0.15; // Delay multiplier (lower = slower lag)

      ringCoords.current.x += (mouseCoords.current.x - ringCoords.current.x) * ringSpeed;
      ringCoords.current.y += (mouseCoords.current.y - ringCoords.current.y) * ringSpeed;

      if (dotRef.current) {
        dotRef.current.style.transform = `translate3d(${mouseCoords.current.x}px, ${mouseCoords.current.y}px, 0)`;
      }
      if (ringRef.current) {
        ringRef.current.style.transform = `translate3d(${ringCoords.current.x}px, ${ringCoords.current.y}px, 0)`;
      }

      animationFrameId = requestAnimationFrame(animateRing);
    };
    animateRing();

    return () => {
      window.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseleave", onMouseLeave);
      document.removeEventListener("mouseenter", onMouseEnter);
      window.removeEventListener("mouseover", onMouseOver);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);

  return (
    <>
      {/* Centered Small Dot */}
      <div
        ref={dotRef}
        className={`custom-dot-cursor ${hidden ? "cursor-hidden" : ""}`}
        style={{
          position: "fixed",
          top: -3,
          left: -3,
          width: 6,
          height: 6,
          borderRadius: "50%",
          backgroundColor: "var(--accent-1)",
          zIndex: 99999,
          pointerEvents: "none",
          willChange: "transform",
          transition: "transform 0.05s linear, opacity 0.3s ease",
          opacity: hidden ? 0 : 1
        }}
      />
      {/* Outer Glow Ring (with blend difference overlay) */}
      <div
        ref={ringRef}
        className={`custom-ring-cursor ${hidden ? "cursor-hidden" : ""} ${hovered ? "cursor-hovered" : ""}`}
        style={{
          position: "fixed",
          top: -18,
          left: -18,
          width: 36,
          height: 36,
          borderRadius: "50%",
          border: "2px solid #ffffff",
          zIndex: 99998,
          pointerEvents: "none",
          mixBlendMode: "difference",
          willChange: "transform",
          transition: "transform 0.08s ease-out, width 0.3s ease, height 0.3s ease, top 0.3s ease, left 0.3s ease, border-color 0.3s ease, opacity 0.3s ease",
          opacity: hidden ? 0 : 0.8
        }}
      />
    </>
  );
};

export default CustomCursor;
